import styles from "./gameModeSelector.module.css";

import ImgBuilder from "../../assets/ImgBuilder";
import AppBar from "../../components/appBar/appBar";
import AbortGame from "../../components/abortGame/abortGame";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useUserData } from "../../functions/updateUserData";
import { useTranslation } from "react-i18next";

const GameModeSelector = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [modeChosen, setModeChosen] = useState(null);
  const [modeChosenActivated, setModeChosenActivated] = useState("");

  const gameModes = t("mode_selection.game_modes_adult", { returnObjects: true });

  const { setUserData } = useUserData();

  const DELAY = 350;

  const activateGameModes = {
    binaryCalssification: () => {
      setUserData((prev) => ({ ...prev, userTraceID: -2 }));
      setTimeout(() => navigate("/topics"), DELAY);
      // setTimeout(() => navigate("/social/truth-seeker"), DELAY);
    },
    messengerGame: () => {
      setUserData((prev) => ({ ...prev, userTraceID: -3 }));
      setTimeout(() => navigate("/social"), DELAY);
      // setTimeout(() => navigate("/social/chaos"), DELAY);
    },
  };

  const handleClick = (gameType) => {
    if (activateGameModes[gameType]) {
      setModeChosenActivated(styles.disappearBox);
      activateGameModes[gameType]();
    } else {
      console.error("Unknown game type:", gameType);
    }
  };

  // // give to one class "choosen" and to the other "notChoosen"
  // const getClassName = (choice) => {
  //   if (modeChosen === null) {
  //     // No class if none is chosen
  //     return ''; 
  //   }
  //   if (modeChosen === choice) {
  //     return styles.modeChosen; // Class for the active choice
  //   }
  //   return styles.modeChosenNot; // Class for the other choice
  // };

  const modeDictionary = gameModes.reduce((acc, item) => {
    acc[item.mode] = {
      name: item.name,
      description: item.description,
      button: item.button,
    };
    return acc;
  }, {});

  const chooseMode = (choice) => {
    setModeChosen((prev) => (prev === choice ? null : choice));
  };

  // // keyboard support for the PNGs
  // const onKeyActivate = (ev, choice) => {
  //   if (ev.key === "Enter" || ev.key === " ") {
  //     ev.preventDefault();
  //     chooseMode(choice);
  //   }
  // };

  return (
    <div className={styles.wrapper}>
      <AppBar />
      <AbortGame />
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>


      <div className={`${styles.boxModeSelector} ${modeChosenActivated}`} style={{ "--hdelay": "400ms" }}>
        <p className={styles.callToActionBox}>
          {t("mode_selection.title")}
        </p>
        <p className={styles.subCallToActionBox}>
          {t("mode_selection.subtitle")}
        </p>
        <div className={styles.gameModesContainer}>
          {gameModes.map((item, idx) =>
            <div key={idx} onClick={() => chooseMode(item.mode)} className={`${styles.optionGame} ${item.mode === modeChosen ? styles.activeMode : ""}`}>
              <div className={`${styles.circleSelected}`}></div>
              <img alt="gameMode" className={styles.imageOptionGame} src={ImgBuilder[item.asset]}/>
              <p className={styles.textOptionGame}>{item.name}</p>
            </div>
          )}
        </div>
        
        {(modeChosen !== null) && 
          <div className={styles.explanationBox}>
            <p className={styles.confirmationExplanationBox}>
              {t("mode_selection.confirmation")}{" "}
              <b>
                {modeDictionary[modeChosen].name}
              </b>
            </p>
            <div className={styles.lowerExplanationBox}>
              <p className={styles.textExplanationBox}>
                {modeDictionary[modeChosen].description}
              </p>
              <button onClick={() => handleClick(modeChosen)} className={styles.buttonExplanationBox}>
                {modeDictionary[modeChosen].button}
              </button>
            </div>
            
          </div>
        }
      </div>

    </div>
  );
};

export default GameModeSelector;
